/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from 'react';
import { IconButton, TextField } from '@material-ui/core';
import { Search, CancelOutlined } from '@material-ui/icons';
import { debounce } from 'lodash';

export function SearchInput({ onChange, set }) {
  const [text, setText] = useState('');

  const searchDebounce = useCallback(debounce(onChange, 800), [onChange]);

  function submit(e) {
    e.preventDefault();
    onChange(text);
    if (set) set.current = text;
  }

  function clear() {
    setText('');
    onChange('');
    if (set) set.current = '';
  }

  return (
    <div className="form-group fv-plugins-icon-container mb-0">
      <div className="d-flex align-items-center">
        <form onSubmit={submit} className="w-100">
          <TextField
            className={`form-control form-control-solid p-2 m-0`}
            value={text}
            placeholder="Search"
            margin="dense"
            variant="standard"
            InputProps={{
              disableUnderline: true,
              startAdornment: (
                <IconButton type="submit" className="p-1">
                  <Search />
                </IconButton>
              ),
              endAdornment: text.length ? (
                <IconButton type="button" onClick={clear} className="p-1">
                  <CancelOutlined />
                </IconButton>
              ) : null,
            }}
            onChange={evt => {
              setText(evt.target.value);
              searchDebounce(evt.target.value);
              if (set) set.current = evt.target.value;
            }}
          />
        </form>
      </div>
    </div>
  );
}
